var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"target":"_blank","href":_vm.url}},[_c('b',[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }